export default "__VITE_ASSET__Cz$bUsNx__"